import { BacklogError } from "../../errors/BacklogError";

export type BacklogDependenciesType = {
	[key: string]: () => unknown;
};

export interface Constructor<T> {
	new (options?: unknown): T;
}

export function createContainer(): BacklogDIContainer {
	return new BacklogContainer();
}

export interface BacklogDIContainer {
	bind(
		className: string,
		classRef: unknown,
		dependencies?: BacklogDependenciesType,
	): void;
	resolve<T>(className: string, dependencies?: unknown): T;
}

class BacklogContainer implements BacklogDIContainer {
	private classMap: Map<
		string,
		{ classRef: Constructor<unknown>; dependencies: BacklogDependenciesType }
	>;

	constructor() {
		this.classMap = new Map();
	}

	public bind(
		className: string,
		classRef: Constructor<unknown>,
		dependencies?: BacklogDependenciesType,
	): void {
		const dep = dependencies ?? {};
		this.classMap.set(className, { classRef, dependencies: dep });
	}

	public resolve<T>(className: string, overrides?: unknown): T {
		const classInfo = this.classMap.get(className);
		if (!classInfo) {
			throw new BacklogError(`Class ${className} not found`);
		}

		const opt = overrides ?? {};

		const { classRef, dependencies } = classInfo;

		const resolved_dependencies = Object.keys(dependencies)
			.filter((k) => !Object.keys(opt).includes(k))
			.map((k) => {
				const dep = dependencies[k as keyof BacklogDependenciesType];
				return [k, dep()];
			});

		const options = Object.assign(
			{},
			Object.fromEntries(resolved_dependencies),
			opt,
		);

		return new classRef(options) as T;
	}
}
